export const NUMERIC_DATA_TYPES = ['number', 'quantity', 'currency'];
export const GST_REG_EX_PATTERN = /^[0-9]{2}[a-zA-Z]{5}[0-9]{4}[a-zA-Z]{1}[1-9A-Za-z]{1}[CZ]{1}[0-9a-zA-Z]{1}$|^[0-9]{4}[a-zA-Z]{3}[0-9]{5}[uUnN]{2}[0-9a-zA-Z]{1}$/;
export const PAN_REG_EX_PATTERN = /[A-Z]{3}[PCFTGHLABJ]{1}[A-Z]{1}[0-9]{4}[A-Z]{1}/;
export const VENDOR_CATEGORIES = [
    { id: 1, label: 'All' },
    { id: 2, label: 'Parts & Accessories' },
    { id: 3, label: 'Tyres' },
    { id: 4, label: 'Battery' },
    { id: 5, label: 'Care & Decor' },
    { id: 6, label: 'Compliance' },
    { id: 7, label: 'Fuel' },
    { id: 8, label:'Repair & Service'},
    { id: 51, label: 'Others' },
];

export const PAYMENT_TERMS = [
    { id: 1, label: 'Advance Payment' },
    { id: 2, label: 'Credit' },
    { id: 3, label: 'Cash On Delivery' }
];

export const PAYMENT_MODE = [
    { id: 1, label: 'Amount' },
    { id: 2, label: 'Percentage (%)' },
];

export const PERIOD_MODE = [
    { id: 1, label: 'Day' },
    { id: 2, label: 'Week' },
    { id: 3, label: 'Month' },
    { id: 4, label: 'Year' }
];

export const IMPORT_PROCESS_STATUS = [
    { status: 1, statusText: 'Pending', className: 'partial' },
    { status: 2, statusText: 'File Uploaded', className: 'partial' },
    { status: 3, statusText: 'File Upload Failed', className: 'partial' },
    { status: 4, statusText: 'Processing', className: 'partial' },
    { status: 5, statusText: 'Partially Updated', className: 'partial' },
    { status: 6, statusText: 'Updated', className: 'partial' },
    { status: 7, statusText: 'Update Failed', className: 'partial' },
];


export const DATETIME_FORMATTER = "ddd, HH:mm, DD-MMM-YY";
export const DATE_FORMATTER = "ddd, DD-MMM-YY";
export const DATEONLY_FORMATTER = "DD-MMM-YY";

export const PO_STATUS = [
    { id: 1, label: 'Open' },
    { id: 2, label: 'Sent' },
    { id: 3, label: 'Fulfilled' },
    { id: 4, label: 'Part Fulfilled' },
    { id: 5, label: 'Cancelled' },
    { id: 6, label: 'Shortclosed' },
    { id: 7, label: 'TBA' },
]

export const TRANSFER_REQUEST_STATUS = [
    { invRequestStatusId: 1, invRequestStatus: 'Open', actionTitle:'Open' },
    { invRequestStatusId: 2, invRequestStatus: 'Sent', actionTitle:'Send' },
    { invRequestStatusId: 3, invRequestStatus: 'Fulfilled', actionTitle:'Fulfill' },
    { invRequestStatusId: 4, invRequestStatus: 'Part Fulfilled', actionTitle:'Part Fulfill' },
    { invRequestStatusId: 5, invRequestStatus: 'Cancelled', actionTitle:'Cancel' },
    { invRequestStatusId: 6, invRequestStatus: 'Rejected', actionTitle:'Reject' },
]

export const TRANSFER_VOUCHER_STATUS = [
    { invVoucherStatusId: 1, invVoucherStatus: 'Open', actionTitle:'Open' },
    { invVoucherStatusId: 2, invVoucherStatus: 'Sent', actionTitle:'Send' },
    { invVoucherStatusId: 3, invVoucherStatus: 'Fulfilled', actionTitle:'Fulfill' },
    { invVoucherStatusId: 4, invVoucherStatus: 'Part Fulfilled', actionTitle:'Part Fulfill' },
    { invVoucherStatusId: 5, invVoucherStatus: 'Cancelled', actionTitle:'Cancel' },
    { invVoucherStatusId: 6, invVoucherStatus: 'Rejected', actionTitle:'Reject' },
]

export const PI_PAYMENT_STATUS = [
    { id: 1, label: 'Paid' },
    { id: 2, label: 'Partial' },
    { id: 3, label: 'Unpaid' },
]

export const TYRE_TUBE_TYPE = [
    { id: 1, label: "TT" },  //Tube Type
    { id: 2, label: "TL" },  //Tubeless
]

export const PURCHASE_INVOICE_PARTICULAR_TYPE_LIST = [
    { id: 1, label: 'Labour' },
    { id: 2, label: 'Parts and Accessories' },
];

export const TABLE_PAGINATION_ROWS_OPTIONS = [5,10,15,20,25,30,35,40,45,50];
export const REPORT_TABLE_PAGINATION_ROWS_OPTIONS = [100,200,300,400,500,600,700,800,900,1000];
export const TABLE_PAGINATION_ROWS_OPTIONS_SELECTED = 25;
export const REPORT_TABLE_PAGINATION_ROWS_OPTIONS_SELECTED = 100;
export const EXPORT_PER_REQUEST_RECORD_LIMIT = 1000;

export const TYRE_DISMOUNT_CONDITION_OPTIONS = [{ label: 'Working', id: 1 }, { label: 'Defective', id: 2 }, { label: 'Scrap', id: 3 }, { label: 'Missing', id: 4 }]
export const BATTERY_DISMOUNT_CONDITION_OPTIONS = [{ label: 'Working', id: 1 }, { label: 'Defective', id: 2 }, { label: 'Scrap', id: 3 }, { label: 'Missing', id: 4 }, {label: 'Discharged', id: 5}]
export const REPAIR_SERVICE_DISMOUNT_CONDITION_OPTIONS = [{ label: 'Working', id: 1 }, { label: 'Defective', id: 2 }, { label: 'Scrap', id: 3 }, { label: 'Missing', id: 4 }]
export const EXTERNAL_TRANSFER_FOR_REPAIR_CONDITION_OPTIONS = [{ label: 'Working', id: 1 }, { label: 'Defective', id: 2 }, { label: 'Scrap', id: 3 }]

//SerialNo pattern
export const SERIAL_NUMBER_PATTERN = /^[a-zA-Z0-9]$/

export const ITEM_VALUES_OPTIONS_INPUT_WISE = [
    { label: 'No', id: 1 },
    { label: 'FIFO Method With GST Breakup', id: 2 },
    { label: 'FIFO Method Without GST Breakup', id: 3 }
];

export const ITEM_VALUES_OPTIONS_LAST_PURCHASE_WISE = [
    { label: 'Last Purchase Price With GST Breakup', id: 4 },
    { label: 'Last Purchase Price Without GST Breakup', id: 5 }
];
